import styled from 'styled-components';

export const TextBodyWithInlineLink = styled.div`
  > div {
    display: inline;

    a {
      margin-right: 0;
    }
  }
`;
